import React, {useState} from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import {FaEye, FaEyeSlash, FaShieldAlt, FaBullhorn} from "react-icons/fa";

const Login = ({onAuthSuccess}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    // Simular autenticación con delay para mostrar loading
    setTimeout(() => {
      if (email === "admin" && password === "123456") {
        onAuthSuccess();
      } else {
        setError("Credenciales incorrectas. Verifica tu usuario y contraseña.");
      }
      setLoading(false);
    }, 1500);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <style jsx>{`
        .form-floating {
          position: relative;
          margin-bottom: 1.5rem;
        }

        .input-icon {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: #6c757d;
        }

        .password-toggle {
          position: absolute;
          right: 1rem;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          color: #6c757d;
          cursor: pointer;
        }

        .security-badge {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #6c757d;
          font-size: 0.9rem;
          margin-top: 1rem;
        }

        .security-badge svg {
          margin-right: 0.5rem;
          color: #25d366;
        }
      `}</style>

      <Container
        fluid
        className="d-flex align-items-center justify-content-center bg-light"
        style={{minHeight: "100vh"}}
      >
        <Row className="justify-content-center w-100">
          <Col md={6} lg={5} xl={4}>
            <div className="text-center mb-4">
              <h2 className="text-dark d-flex align-items-center justify-content-center mb-1">
                <FaBullhorn
                  className="me-2"
                  style={{color: "#0ea5e9", fontSize: "1.5rem"}}
                />
                PorterCom
              </h2>
              <p className="text-muted">
                Plataforma de Comunicaciones Empresariales
              </p>
            </div>

            <Card className="shadow-sm rounded-4 border-0">
              <Card.Header className="bg-white p-4 border-bottom-0 text-center">
                <h4 className="fw-bold mb-1">Iniciar Sesión</h4>
                <p className="text-muted mb-0">
                  Bienvenido. Ingresa tus credenciales.
                </p>
              </Card.Header>
              <Card.Body className="p-4">
                {error && (
                  <Alert variant="danger" className="border-0">
                    <strong>Error:</strong> {error}
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Usuario</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ingresa tu usuario"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={loading}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Contraseña</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="Ingresa tu contraseña"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        disabled={loading}
                      />
                      <Button
                        variant="outline-secondary"
                        onClick={togglePasswordVisibility}
                        disabled={loading}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </Button>
                    </InputGroup>
                  </Form.Group>

                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <Form.Check
                      type="checkbox"
                      id="rememberMe"
                      label="Recordarme"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                      disabled={loading}
                    />
                    <a href="#forgot" className="small text-decoration-none">
                      ¿Olvidaste tu contraseña?
                    </a>
                  </div>

                  <div className="d-grid">
                    <Button
                      type="submit"
                      variant="primary"
                      size="lg"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-2"
                          />
                          Iniciando...
                        </>
                      ) : (
                        "Acceder"
                      )}
                    </Button>
                  </div>

                  <div className="text-center mt-3">
                    <small className="text-muted d-flex align-items-center justify-content-center">
                      <FaShieldAlt className="me-1 text-success" /> Conexión
                      segura
                    </small>
                  </div>
                </Form>
              </Card.Body>
            </Card>
            <div className="text-center mt-4">
              <small className="text-muted">
                &copy; {new Date().getFullYear()} PorterCom. Todos los derechos
                reservados.
              </small>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Login;
